import React from 'react'
import ContentBox from '../../../../layout/component/ContentBox'
import Row from '../../../../bootstrap/component/Row'
import Checkbox from '../../../../form/component/Checkbox'
import Column from '../../../../bootstrap/component/Column'

const Finding = ({ options, anamnesis, saveAnamnesis, changeAnamnesis }) => {

    const changeFormData = (name, value) => {
        changeAnamnesis('formData', {
            ...anamnesis.formData,
            [name]: value,
        }, anamnesis.templateKey)
    }

    return (
        <div>
        {options.map((option, i) => {
            return (
                <div key={i}>
                    {option.subCategory}
                    <Row key={option.subCategory+i}  top="L">
                        {option.findings.map((finding, index) => {
                            const isFindingChecked = anamnesis.formData[finding.name] && anamnesis.formData[finding.name] === true
                            return (
                                <Column key={option.keyPrefix+index} size={5}>
                                <Checkbox
                                    key={option.keyPrefix+index}
                                    onChange={() => {
                                            changeFormData(finding.name, !isFindingChecked)
                                            saveAnamnesis(anamnesis.templateKey)
                                        }
                                    }
                                    name="isFindingChecked"
                                    object={{ isFindingChecked }}>
                                    {finding.label}
                                </Checkbox>
                                </Column>
                            )
                        })}
                    </Row>
                </div>
            )
        })}
        </div>
    )
}

const ZAHNBEZOGEN = [
    {
        label: 'Parodontitis',
        name: 'zahnbezogenParodontitis',
    },
    {
        label: 'Endodontisches Problem',
        name: 'zahnbezogenEndodontischesProblem',
    },
    {
        label: 'Trauma',
        name: 'zahnbezogenTrauma',
    },
]

const AESTHETISCHE_ERWARTUNG = [
    {
        label: 'hoch',
        name: 'aesthetischeErwartungHoch',
    },
    {
        label: 'mittel',
        name: 'aesthetischeErwartungMittel',
    },
    {
        label: 'niedrig',
        name: 'aesthetischeErwartungNiedrig',
    },
]

const RESTAURATION = [
    {
        label: 'Einzelzahnversorgung',
        name: 'restaurationEinzelzahnversorgung',
    },
    {
        label: 'Mehrfachversorgung',
        name: 'restaurationMehrfachversorgung',
    },
    {
        label: 'zementiert',
        name: 'restaurationZementiert',
    },
    {
        label: 'verschraubt',
        name: 'restaurationVerschraubt',
    },
    {
        label: 'PV gewünscht',
        name: 'restaurationPVgewünscht',
    },
]

const DICKE_DES_ALVEOLARKAMMS = [
    {
        label: 'dünn',
        name: 'dickeDesAlveolarkammsDuenn',
    },
    {
        label: 'breit',
        name: 'dickeDesAlveolarkammsBreit',
    },
    {
        label: 'c4',
        name: 'dickeDesAlveolarkammsC4',
    },
]

const BEFESTIGTE_GINGIVA = [
    {
        label: 'dünn',
        name: 'befestigteGingivaDuenn',
    },
    {
        label: 'dick',
        name: 'befestigteGingivaDick',
    },
]

const PALPATION = [
    {
        label: 'gut',
        name: 'befestigteGingivaGut',
    },
    {
        label: 'mittel',
        name: 'befestigteGingivaMittel',
    },
    {
        label: 'unzureichend',
        name: 'befestigteGingivaUnzureichend',
    },
]

const PRAEIMPLANTARE_VORBEHANDLUNG = [
    {
        label: 'Prämedikation (bitte ins Kommentarfeld schreiben)',
        name: 'praeimplantaereVorbehandlungPraemedikation',
    },
    {
        label: 'Weichgewebsmanagement',
        name: 'praeimplantaereVorbehandlungWeichgewebsmanagement',
    },
]

const KNOCHENMANAGEMENT = [
    {
        label: 'Augmentation',
        name: 'knochenmanagementAugmentation',
    },
    {
        label: 'Sinuslift',
        name: 'knochenmanagementSinuslift',
    },
    {
        label: 'Membran',
        name: 'knochenmanagementMembran',
    },
    {
        label: 'GBR',
        name: 'knochenmanagementGBR',
    },
]

const MUNDOEFFNUNG = [
    {
        label: '<2 Finger',
        name: 'mundoeffnungL2finger',
    },
    {
        label: '>2 Finger',
        name: 'mundoeffnungM2finger',
    },
    {
        label: '>3 Finger',
        name: 'mundoeffnungM3finger',
    },
]

const IMPLANTATSYSTEM = [
    {
        label: 'MIS',
        name: 'implantatsystemMIS',
    },
    {
        label: 'Camlog',
        name: 'implantatsystemCamlog',
    },
    {
        label: 'Conelog',
        name: 'implantatsystemConelog',
    },
    {
        label: 'Straumann',
        name: 'implantatsystemStraumann',
    },
    {
        label: 'ICX',
        name: 'implantatsystemICX',
    },
    {
        label: 'other (bitte ins Kommentarfeld schreiben)',
        name: 'implantatsystemOther',
    },
]

const FINDINGS = [
    {
        category: 'Zahnbezogen',
        options: [
            {
                subCategory: "",
                keyPrefix: 'zahnbezogen',
                findings: ZAHNBEZOGEN,
            }
        ]
    },
    {
        category: 'Ästhetische Erwartung',
        options: [
            {
                subCategory: "",
                keyPrefix: 'aesthetischeErwartung',
                findings: AESTHETISCHE_ERWARTUNG,
            }
        ]
    },
    {
        category: 'Restauration',
        options: [
            {
                subCategory: "",
                keyPrefix: 'restauration',
                findings: RESTAURATION,
            }
        ]
    },
    {
        category: 'Knochenvolumen',
        options: [
            {
                subCategory: "Dicke des Alveolarkamms",
                keyPrefix: 'dickeDesAlveolarkamms',
                findings: DICKE_DES_ALVEOLARKAMMS,
            },
            {
                subCategory: "Befestigte Gingiva",
                keyPrefix: 'befestigteGingiva',
                findings: BEFESTIGTE_GINGIVA,
            },
            {
                subCategory: "Palpation",
                keyPrefix: 'palpation',
                findings: PALPATION,
            }
        ]
    },
    {
        category: 'Präimplantäre Vorbehandlung',
        options: [
            {
                subCategory: "",
                keyPrefix: 'praeimplantaereVorbehandlung',
                findings: PRAEIMPLANTARE_VORBEHANDLUNG,
            }
        ]
    },
    {
        category: 'Präimplantäre Vorbehandlung',
        options: [
            {
                subCategory: "Knochenmanagement",
                keyPrefix: 'knochenmanagement',
                findings: KNOCHENMANAGEMENT,
            }
        ]
    },
    {
        category: 'Mundöffnung',
        options: [
            {
                subCategory: "",
                keyPrefix: 'mundoeffnung',
                findings: MUNDOEFFNUNG,
            }
        ]
    },
    {
        category: 'Implantatsystem',
        options: [
            {
                subCategory: "",
                keyPrefix: 'implantatsystem',
                findings: IMPLANTATSYSTEM,
            }
        ]
    },
]

const ImplantConsultationAndFindings = ({
  ...props
}) => {
    return (
        <div className="findings">
            <ContentBox>
                {FINDINGS.map((finding, i) => {
                    const findingProps = {
                        ...props,
                        options:finding.options
                    }
                    return (
                        <div key={finding.category+i}>
                            <Row top="L">
                                <h2>{finding.category}</h2>
                            </Row>
                            <Finding key={finding.category+i} {...findingProps} />
                            <br/>
                        </div>
                    )
                })}
            </ContentBox>
        </div>
    )
}

export default ImplantConsultationAndFindings



// WEBPACK FOOTER //
// ./src/modules/anamnesis/component/anamnesis/renderer/ImplantConslutationAndFindings.js